import { apiClient } from '@/services/api/apiClient';
import { ENDPOINTS } from '@/services/api/endpoints';

/**
 * The operational dashboard and the admin screen that decides who sees it.
 *
 * `getMyAccess` is callable by anyone signed in — it answers only a boolean
 * about the caller. Everything else is gated on the server: the dashboard on a
 * per-account grant, the grant management on the Admin role.
 */
export const operationalDashboardService = {
    async getDashboard(rangeParams = {}) {
        const { data } = await apiClient.get(ENDPOINTS.OPERATIONAL_DASHBOARD.ROOT, {
            params: rangeParams,
        });
        return data?.data ?? null;
    },

    /** The reports behind one indicator's figure. Read-only. */
    async listEntries(indicatorId, rangeParams = {}) {
        const { data } = await apiClient.get(
            ENDPOINTS.OPERATIONAL_DASHBOARD.ENTRIES(indicatorId),
            { params: rangeParams },
        );
        return data?.data ?? [];
    },

    /** Whether the signed-in account may see the dashboard. */
    async getMyAccess() {
        const { data } = await apiClient.get(
            ENDPOINTS.OPERATIONAL_DASHBOARD.MY_ACCESS,
        );
        return Boolean(data?.data?.hasAccess);
    },

    /** Everyone who currently holds a grant. Admin only. */
    async listGrants() {
        const { data } = await apiClient.get(ENDPOINTS.OPERATIONAL_DASHBOARD.ACCESS);
        return data?.data ?? [];
    },

    /** The full set of viewers, not a delta. An empty array revokes everyone. */
    async setGrants(accountIds) {
        const { data } = await apiClient.put(
            ENDPOINTS.OPERATIONAL_DASHBOARD.ACCESS,
            { accountIds },
        );
        return data?.data ?? [];
    },
};

export default operationalDashboardService;
